import { cn } from '@/shared/lib/cn';
import styles from './OrbitField.module.css';

export const OrbitField: React.FC = () => (
  <div className={styles.field} aria-hidden>
    <div className={styles.core} />
    {[styles.o1, styles.o2, styles.o3, styles.o4].map((o, i) => (
      <div key={i} className={cn(styles.orbit, o)}>
        <span className={styles.ring} />
        <span className={styles.satellite}>
          <span className={styles.planet} />
        </span>
      </div>
    ))}
  </div>
);
